import { useContext, useEffect, useState } from "react";
import LogCard from "../../Components/Modal/Log";
import api from "../../api/api";
import Pagination from "../../Components/Pagination";
import { Oval } from "react-loader-spinner";

const AdminLogsPage = () => {
    
  const [logs, setLogs] = useState([])
  const [totalPage, setTotalPage] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const [success, setSuccess] = useState([true, false])
  const [isSuccess, setIsSuccess] = useState(null)
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState(false)


  const [filters, setFilters] = useState({
        date: null,
        status: null,
        searchTerm: null,
    });

  const handleFilterChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleSearch = () => {
        setSearch(true); // Reset to first page when applying filters
        setLoading(true)
  };


  
  useEffect(()=>{

    const getLogs = async ()=>{

        try{
            const Logs = await api.get('activities', {
              params : {
                page : currentPage,
                ...filters
              }
            })

            console.log(Logs.data)
            setLogs([...Logs.data.activities.rows])
            setTotalPage(Math.ceil(Logs.data.activities.count / 20))
            setLoading(false)
            setSearch(false);

            

        }catch(e){

            console.log(e)
        }
    }

    getLogs()
    
  }, [currentPage, search === true])

  
  return !loading ?(
    <div className="min-h-screen p-6 ">
      <h1 className="mb-4 text-2xl font-bold dark:text-gray-200">Logs</h1>

      <div className="p-4 mb-4 bg-white rounded-lg shadow-lg dark:bg-indigo-600">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-4">
            <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">Date</label>
                <input
                    type="date"
                    name="date"
                    value={filters.date}
                    onChange={handleFilterChange}
                    className="block w-full p-2 mt-1 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                />
            </div>
            
            <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">Statut</label>
                <select
                    name="status"
                    value={filters.status}
                    onChange={handleFilterChange}
                    className="block w-full p-2 mt-1 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                >
                    <option value="">Tous les statuts</option>
                    <option value="success">Succès</option>
                    <option value="failed">Échec</option>
                </select>
            </div>
            <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">Rechercher</label>
                <input
                    type="text"
                    name="searchTerm"
                    value={filters.searchTerm}
                    onChange={handleFilterChange}
                    className="block w-full p-2 mt-1 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                    placeholder="Rechercher par action"
                />
            </div>
        </div>
        <div className="flex justify-end mt-4 space-x-4">
            <button
                onClick={handleSearch}
                className="px-4 py-2 font-semibold text-white bg-gray-800 rounded-lg shadow hover:bg-gray-700"
            >
                Rechercher
            </button>
            <button
                onClick={() => setFilters({
                    startDate: '',
                    endDate: '',
                    status: '',
                    searchTerm: '',
                })}
                className="px-4 py-2 font-semibold text-gray-700 bg-gray-100 rounded-lg shadow hover:bg-gray-200"
            >
                Réinitialiser
            </button>
        </div>
      </div>
      <div className="p-6 bg-gray-200 rounded-lg dark:bg-gray-700">
        <div className="flex flex-row flex-wrap items-center justify-start gap-3 px-4 my-4">
            {
                success.map((item, idx)=>(
                    <button className={`text-sm px-2 py-1 rounded-xl cursor-pointer border border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-400 transition-all duration-300 ${isSuccess === item ? 'bg-indigo-600 px-4 border-0 text-white shadow-lg transform scale-105' : 'bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'}`}
                        onClick={()=>{
                            
                            if(isSuccess === item){
                                setIsSuccess(null)
                            }else{
                                
                                setIsSuccess(item)
                            }
                        }}
                    >
                        {item ? 'Success' : 'Fail'}
                    </button>
                ))
                }
            </div>
        <div className="grid gap-2 m-5">
          {logs.map(log =>{

            if(isSuccess === log.success || isSuccess == null){

              return (
                <LogCard key={log.id} log={log} />
              )
              
            }


          } )}
          
        </div>
      </div>
      

      <Pagination
        currentPage={currentPage}
        totalPages={totalPage}
        onPageChange={(page)=>setCurrentPage(page)}
      />
    </div>
  ) : (

    <div className="flex items-center justify-center">
      
      <Oval
        height={20}
        width={20}
        color="#ffffff"
        visible={true}
        ariaLabel="oval-loading"
        secondaryColor="#cccccc"
        strokeWidth={2}
        strokeWidthSecondary={2}
      />
    </div>
  );
};

export default AdminLogsPage;